export function insertIf(condition: boolean, object: any) {
  return condition ? [object] : [];
}
